import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  useToast,
  Switch,
  SimpleGrid,
  Textarea,
} from "@chakra-ui/react";
import { supabase } from "../../lib/supabaseClient";

const EditMusicianModal = ({ isOpen, onClose, musician, onSave }) => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  useEffect(() => {
    if (isOpen && musician) {
      setFormData({ ...musician });
    }
  }, [isOpen, musician]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" || type === "switch" ? checked : value;
    setFormData((prev) => ({ ...prev, [name]: val }));
  };

  const handleSave = async () => {
    setLoading(true);
    const { created_date, modified_date, id, ...updateData } = formData;

    try {
      const { error } = await supabase
        .from("musician")
        .update({
          ...updateData,
          modified_date: new Date().toISOString(),
        })
        .eq("id", musician.id);

      if (error) {
        toast({
          title: "수정 실패",
          description: error.message,
          status: "error",
        });
      } else {
        toast({ title: "뮤지션 정보 수정 완료", status: "success" });
        onSave();
        onClose();
      }
    } catch (error) {
      toast({
        title: "수정 실패",
        description: error.message,
        status: "error",
      });
    }

    setLoading(false);
  };

  const renderInput = (key, value) => {
    const isBoolean = typeof value === "boolean";
    const isTextarea = ["biography", "introduction", "memo"].includes(key);

    if (isBoolean) {
      return <Switch name={key} isChecked={value} onChange={handleChange} />;
    }

    if (isTextarea) {
      return (
        <Textarea
          name={key}
          value={value || ""}
          onChange={handleChange}
          rows={3}
        />
      );
    }

    const isDate = key.includes("_at") || key.includes("_date");
    return (
      <Input
        name={key}
        value={value || ""}
        onChange={handleChange}
        type={isDate ? "datetime-local" : "text"}
      />
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>뮤지션 정보 수정</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
            {Object.keys(formData).map((key) => {
              if (
                [
                  "id",
                  "created_date",
                  "modified_date",
                  "musician_idx",
                  "laeebly_id",
                ].includes(key)
              ) {
                return null;
              }

              return (
                <FormControl key={key}>
                  <FormLabel>{key}</FormLabel>
                  {renderInput(key, formData[key])}
                </FormControl>
              );
            })}
          </SimpleGrid>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            취소
          </Button>
          <Button colorScheme="blue" onClick={handleSave} isLoading={loading}>
            저장
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditMusicianModal;
